<template>
  <v-layout>
    <v-flex xs12 style="margin-top:20px;">
      <v-text-field
          v-model="content.PollAlias"
          :label="$t('poll.alias')"
          hideDetails
          @input="handleChangeIsModified"
          style="margin-bottom: 20px;"
        />
      <add-item :onAddItem="handleAddItem" />
      <v-card
        v-for="item in content.PollFormData"
        :key="item.id"
        style="margin-top:30px;padding: 20px;"
      >
        <v-btn
          absolute
          dark
          fab
          top
          right
          small
          color="red"
          @click="handleDeleteItem(item.id)"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
        <translate
          v-model="item.question"
          :languages="languages"
          :label="$t('poll.question')"
          @input="handleChangeIsModified"
        />
        <selection
          v-if="item.type==='multiSelection' || item.type==='singleSelection' "
          :item="item"
          :onAddAnswer="() => handleAddAnswer(item.id)"
          :onChangeIsModified="handleChangeIsModified"
        />
        <v-layout wrap v-else-if="item.type==='number'">
          <v-flex xs6>
          <v-text-field
            v-model="item.min"
            type="number"
            label="Min"
          />
          </v-flex>
          <v-flex xs6>
          <v-text-field
            v-model="item.max"
            type="number"
            label="Max"
          />
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import uuidv1 from 'uuid/v1'
  import Translate from '@/components/Translate'
  import AddItem from './AddItem'
  import Selection from './Selection'
  export default {
    components: {
      AddItem,
      Selection,
      Translate
    },
    props: {
      content: {
        type: Object,
        required: true
      },
    },
    computed: {
      // ...mapState('app',['isAdmin', 'contents', 'enterpriseColor', 'BGColor', 'Color', 'BGColorSecundary', 'ColorSecundary', 'GlobalFont', 'collapseContent', 'saving']),
      languages () {
        return this.$store.state.app.Languages
      },
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
    },
    methods: {
      handleAddItem (value) {
        if (!this.content.PollFormData) this.content.PollFormData = []
        
        const newItem = {
          id: uuidv1(),
          type: value,
          question: {
            es: ''
          },
          values: []
        }

        if (value === 'number') {
          newItem.min = 0
          newItem.max = 100
        }

        this.content.PollFormData.push(newItem)
        this.content.UpdateKey = uuidv1()
      },
      handleAddAnswer (id) {
        this.content.PollFormData.filter(x => x.id === id) [0].values.push({
          id: uuidv1(),
          answer: {
            es: ''
          },
        })
        this.content.UpdateKey = uuidv1()
      },
      handleChangeIsModified () {
        this.content.UpdateKey = uuidv1()
      },
      handleDeleteItem (value) {
        this.content.PollFormData = this.content.PollFormData.filter(x => x.id !== value)
      }
    }
  }
</script>
